module.exports = __webpack_public_path__ + "static/feature-search-43dd305874786b9e03e3caaad86b7aec.png";